import t_08_2310 from './KZ.T.08.2310.svg'
import t_08_2310_b from './KZ.T.08.2310 black.svg'

export default [
  t_08_2310,
  t_08_2310_b,
]
